/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Relationships } from './Relationships';
import {
    RelationshipsFromJSON,
    RelationshipsFromJSONTyped,
    RelationshipsToJSON,
    RelationshipsToJSONTyped,
} from './Relationships';
import type { NoteData } from './NoteData';
import {
    NoteDataFromJSON,
    NoteDataFromJSONTyped,
    NoteDataToJSON,
    NoteDataToJSONTyped,
} from './NoteData';

/**
 * 
 * @export
 * @interface BulkUpdateShiftsDataBaseData
 */
export interface BulkUpdateShiftsDataBaseData {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateShiftsDataBaseData
     */
    employeeId?: number | null;
    /**
     * Whether to offer the shift to all eligible employees
     * @type {boolean}
     * @memberof BulkUpdateShiftsDataBaseData
     */
    open?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof BulkUpdateShiftsDataBaseData
     */
    startsAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BulkUpdateShiftsDataBaseData
     */
    endsAt?: Date;
    /**
     * 
     * @type {NoteData}
     * @memberof BulkUpdateShiftsDataBaseData
     */
    noteData?: NoteData;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateShiftsDataBaseData
     */
    acknowledged?: boolean;
    /**
     * 
     * @type {Relationships}
     * @memberof BulkUpdateShiftsDataBaseData
     */
    tagIds?: Relationships;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateShiftsDataBaseData
     */
    isDownloadedToPortal?: boolean;
}

/**
 * Check if a given object implements the BulkUpdateShiftsDataBaseData interface.
 */
export function instanceOfBulkUpdateShiftsDataBaseData(value: object): value is BulkUpdateShiftsDataBaseData {
    return true;
}

export function BulkUpdateShiftsDataBaseDataFromJSON(json: any): BulkUpdateShiftsDataBaseData {
    return BulkUpdateShiftsDataBaseDataFromJSONTyped(json, false);
}

export function BulkUpdateShiftsDataBaseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateShiftsDataBaseData {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'open': json['open'] == null ? undefined : json['open'],
        'startsAt': json['startsAt'] == null ? undefined : (new Date(json['startsAt'])),
        'endsAt': json['endsAt'] == null ? undefined : (new Date(json['endsAt'])),
        'noteData': json['noteData'] == null ? undefined : NoteDataFromJSON(json['noteData']),
        'acknowledged': json['acknowledged'] == null ? undefined : json['acknowledged'],
        'tagIds': json['tagIds'] == null ? undefined : RelationshipsFromJSON(json['tagIds']),
        'isDownloadedToPortal': json['isDownloadedToPortal'] == null ? undefined : json['isDownloadedToPortal'],
    };
}

  export function BulkUpdateShiftsDataBaseDataToJSON(json: any): BulkUpdateShiftsDataBaseData {
      return BulkUpdateShiftsDataBaseDataToJSONTyped(json, false);
  }

  export function BulkUpdateShiftsDataBaseDataToJSONTyped(value?: BulkUpdateShiftsDataBaseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'open': value['open'],
        'startsAt': value['startsAt'] == null ? undefined : ((value['startsAt']).toISOString()),
        'endsAt': value['endsAt'] == null ? undefined : ((value['endsAt']).toISOString()),
        'noteData': NoteDataToJSON(value['noteData']),
        'acknowledged': value['acknowledged'],
        'tagIds': RelationshipsToJSON(value['tagIds']),
        'isDownloadedToPortal': value['isDownloadedToPortal'],
    };
}

